import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATEGORIES = ["Todos", "Vestidos", "Blusas", "Camisas", "Conjuntos", "Calças", "Shorts", "Saias", "Macacões", "Blazers", "Jaquetas", "Moda Plus Size", "Acessórios"];
const COLLECTIONS = ["Todas", "Primavera", "Verão", "Outono", "Inverno"];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "Todos";
  const col = params.get("col") || "Todas";
  const tag = params.get("tag") || "";

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const filtered = useMemo(() => products.filter((p) =>
    (cat === "Todos" || p.category === cat) &&
    (col === "Todas" || p.collection === col) &&
    (!tag || p.tags?.includes(tag))
  ), [products, cat, col, tag]);

  const setParam = (k, v) => {
    const next = new URLSearchParams(params);
    if (v && v !== "Todos" && v !== "Todas") next.set(k, v); else next.delete(k);
    setParams(next);
  };

  return (
    <div data-testid="shop-page" className="max-w-[1600px] mx-auto px-5 md:px-10 py-16">
      <div className="mb-4"><p className="label-caps text-rose">Loja</p></div>
      <h1 className="font-serif-display font-light text-white text-5xl md:text-7xl tracking-tighter leading-none mb-10">
        {tag === "promocao" ? "Ofertas Especiais" : cat !== "Todos" ? cat : col !== "Todas" ? `Coleção ${col}` : "Todas as Peças"}
      </h1>

      <div className="flex flex-wrap gap-4 mb-12 border-y border-line py-5">
        <div className="min-w-[200px]">
          <Select value={cat} onValueChange={(v) => setParam("cat", v)}>
            <SelectTrigger data-testid="filter-category" className="bg-surface border-line text-white rounded-none"><SelectValue placeholder="Categoria" /></SelectTrigger>
            <SelectContent className="bg-surface2 border-line text-white">
              {CATEGORIES.map((c) => <SelectItem key={c} value={c} className="focus:bg-rose focus:text-ink">{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="min-w-[200px]">
          <Select value={col} onValueChange={(v) => setParam("col", v)}>
            <SelectTrigger data-testid="filter-collection" className="bg-surface border-line text-white rounded-none"><SelectValue placeholder="Coleção" /></SelectTrigger>
            <SelectContent className="bg-surface2 border-line text-white">
              {COLLECTIONS.map((c) => <SelectItem key={c} value={c} className="focus:bg-rose focus:text-ink">{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <p className="ml-auto self-center text-white/40 text-sm" data-testid="result-count">{filtered.length} peça(s)</p>
      </div>

      {filtered.length === 0 ? (
        <p className="text-white/50 py-20 text-center">Nenhuma peça encontrada com esses filtros.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
          {filtered.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
